import { useEffect } from 'react';
import { useRoutes, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import CssBaseline from '@material-ui/core/CssBaseline';
import { SnackbarProvider } from 'notistack';

import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { getProfileAction } from './store/actions/profile';

import theme from './theme';
import routes from './routes';

const App = () => {
	const routing = useRoutes(routes);
	const location = useLocation();
	const dispatch = useDispatch();

	const profile = useSelector((state) => state.profile, shallowEqual);

	useEffect(() => {
		dispatch(getProfileAction());
		// init Paddle
		// const paddle = window.Paddle;
		// if (process.env.NODE_ENV === 'development') {
		// 	paddle.Environment.set('sandbox');
		// }
		// paddle.Setup({ vendor: parseInt(process.env.REACT_APP_PADDLE_VENDOR, 10) });
	}, []);

	if (profile.isAuth === null) return null;

	return (
		<SnackbarProvider maxSnack={6}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{/* <GlobalStyles /> */}
				{profile.isAuth === false && !['/login', '/register'].includes(location.pathname) ? (
					<Navigate to="/login" />
				) : (
					routing
				)}
			</ThemeProvider>
		</SnackbarProvider>
	);
};

export default App;
